// extracted by mini-css-extract-plugin
export default {"item":"SearchResult_item__IFUU4"};